import {
  addHtmlElementClass,
  removeHtmlElementClass,
  renderWebComponent,
  string2obj,
  obj2string,
  parseAmount,
  CURRENCY_EURO,
  removeHtmlChildren,
  getHtmlElement,
  appendHtmlElementChild,
  addHtmlElementEventListener,
  highDebouncedFunction,
  isDefined,
  setHtmlElementContent,
  scrollHtmlElementIntoView,
  EASE_IN_TRANSITION_TIME,
  sanitize,
  enableHtmlElement,
  veryHighDebouncedFunction,
  parseTimeRange,
  selectHtmlElement,
  setHtmlElementValue,
  SUBMISSION_LISTS_HOME_PICK_UP_TIME_RANGES,
  checkHtmlElement,
  INSURANCE_TOU_ACCEPTED_KEY_FOR_SESSION_STORAGE,
  INSURANCE_GUIDELINES_ACCEPTED_KEY_FOR_SESSION_STORAGE,
  submissionListMaxUsableCredit,
  isPresent,
  parsePotentiallyFreeAmount,
  pricesRangeCollapse
} from "../../../utils/utils";
import I18n from 'i18n.js.erb';
import commonStyles from '../../styles/web-components.common.css';
import submissionListsStyles from '../../styles/submission-lists.css';
import { EventBusComponent } from "../EventBusComponent";


export class SubmissionListAdditionalServicesComponent extends HTMLElement {
  props = {};
  insurance = false;
  insuranceRangeId = null;
  submissionListEstimatedValue = null;
  isUserWalletSliderDragging = false;
  usedCredit = null;

  static get observedAttributes() {
    return [ 'props' ];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (newValue)
      this.props = string2obj(newValue);
    this.setInsuranceParams();
    this.render();
  }

  constructor() {
    super();
    this.attachShadow({ mode: 'open'});
    this.eventBus = EventBusComponent.getInstance();
  }

  connectedCallback() {
    this.eventBus.subscribe('changed-grader-company', (newGraderCompany) => {
      this.updateSubmissionList(['grader_company_id', 'grader_company_shipment_address_id'], [newGraderCompany.id, newGraderCompany.default_shipment_address?.id]);
    });

    this.eventBus.subscribe('updated-submission-list-state', (submissionList) => this.updateSubmissionListState(submissionList));

    for (const key of ['favorite_day', 'favorite_hour', 'home_pick_up_address', 'home_pick_up_note', 'shipment_address', 'shipment_note']) {
      addHtmlElementEventListener(this.shadowRoot, `${key}_container`, 'mouseover' , (e) => this.eventBus.publish(`enable-hover-question-tooltip-${key}_container`, true));
      addHtmlElementEventListener(this.shadowRoot, `${key}_container`, 'mouseout' , (e) => this.eventBus.publish(`enable-hover-question-tooltip-${key}_container`, false));
    }
    addHtmlElementEventListener(this.shadowRoot, 'favorite_day', 'input', (e) => this.updateSubmissionList(["home_pick_up_favorite_day"], [e.target.value]));
    addHtmlElementEventListener(this.shadowRoot, 'favorite_hour', 'change', (e) => this.updateSubmissionList(["home_pick_up_favorite_hour"], [e.target.value]));

    addHtmlElementEventListener(this.shadowRoot, 'home_pick_up_note', 'input', (e) => highDebouncedFunction(this.updateSubmissionList, [['home_pick_up_note'], [e.target.value]]));
    addHtmlElementEventListener(this.shadowRoot, 'shipment_note', 'input', (e) => highDebouncedFunction(this.updateSubmissionList, [['shipment_note'], [e.target.value]]));
    
    addHtmlElementEventListener(this.shadowRoot, 'add_insurance_btn', 'click', (e) => this.handleChangeInsuranceService(true));
    addHtmlElementEventListener(this.shadowRoot, 'remove_insurance_btn', 'click', (e) => this.handleChangeInsuranceService(false));

    addHtmlElementEventListener(this.shadowRoot, 'user_wallet_slider', 'mousedown', () => this.isUserWalletSliderDragging = true);
    addHtmlElementEventListener(this.shadowRoot, 'user_wallet_slider', 'touchstart', () => this.isUserWalletSliderDragging = true);
    addHtmlElementEventListener(this.shadowRoot, 'user_wallet_slider', 'mousemove', (e) => this.handleDragUserWalletSlider(e));
    addHtmlElementEventListener(this.shadowRoot, 'user_wallet_slider', 'touchmove', (e) => this.handleDragUserWalletSlider(e));
    addHtmlElementEventListener(this.shadowRoot, 'user_wallet_slider', 'mouseup', () => this.handleOnUserWalletSliderMouseUp());
    addHtmlElementEventListener(this.shadowRoot, 'user_wallet_slider', 'touchend', () => this.handleOnUserWalletSliderMouseUp());
    addHtmlElementEventListener(this.shadowRoot, 'user_wallet_slider', 'input', (e) => this.handleOnUserWalletSliderChange(e));
  }


  // Funzione che renderizza a video, mediante un'animazione di tipo ease-in, i subbanner dei vari servizi aggiuntivi
  // che l'utente può aggiungere alla sua submission list
  handleRenderingSubbanner(id, show, fun) {
    if (show) {
      addHtmlElementClass(this.shadowRoot, id, 'slide-down');
      removeHtmlElementClass(this.shadowRoot, id, 'slide-up');
      addHtmlElementClass(this.shadowRoot, id, 'service-subbanner');
    } else {
      addHtmlElementClass(this.shadowRoot, id, 'slide-up');
      removeHtmlElementClass(this.shadowRoot, id, 'slide-down');

      setTimeout(() => {
        removeHtmlElementClass(this.shadowRoot, id, 'service-subbanner')
      }, EASE_IN_TRANSITION_TIME);
    }
    if (fun)
      setTimeout(() => fun(), 2 * (EASE_IN_TRANSITION_TIME / 3))
  }


  // Funzione che gestisce la visualizzazione dei controlli grafici da renderizzare a video per permettere all'utente
  // di scegliere i servizi aggiuntivi da includere alla sua submission list
  refreshInterface() {
    // Gestisco il rendering sull'interfaccia grafica dell'intero form dei servizi aggiuntivi proposti all'utente
    if (this.props.submissionList.grader_company.home_pick_up_method ||
        this.props.submissionList.grader_company.return_delivery_method ||
        this.props.submissionList.grader_company.has_insurance_options)
      removeHtmlElementClass(this.shadowRoot, "additional_services_container", "d-none");
    else
      addHtmlElementClass(this.shadowRoot, "additional_services_container", "d-none");




    // Gestisco il rendering sull'interfaccia grafica del banner che informa l'utente delle spedizioni gratuite
    // per ordini che raggiungono un certo importo
    if ((this.props.submissionList.grader_company.home_pick_up_method || this.props.submissionList.grader_company.return_delivery_method) &&
        isDefined(this.props.submissionList.grader_company.shipping_discount_sub_list_amount_threshold)) {
      removeHtmlElementClass(this.shadowRoot, "free_shipping", "d-none");
      addHtmlElementClass(this.shadowRoot, "free_shipping", "d-block");
      let freeShippingMessage = '';
      let freeShippingSubMessage = '';
      if (this.props.submissionList.free_shipping) {
        if (this.props.submissionList.grader_company.home_pick_up_method && this.props.submissionList.grader_company.return_delivery_method) {
          freeShippingMessage = I18n.t('js.editSubmissionListPage.webComponent.draft.freeShipping.mainTitle_2');
          freeShippingSubMessage = I18n.t('js.editSubmissionListPage.webComponent.draft.freeShipping.subTitle_2');
        }
        else if (this.props.submissionList.grader_company.home_pick_up_method) {
          freeShippingMessage = I18n.t('js.editSubmissionListPage.webComponent.draft.freeShipping.mainTitle_3');
          freeShippingSubMessage = I18n.t('js.editSubmissionListPage.webComponent.draft.freeShipping.subTitle_3');
        }
        else if (this.props.submissionList.grader_company.return_delivery_method) {
          freeShippingMessage = I18n.t('js.editSubmissionListPage.webComponent.draft.freeShipping.mainTitle_4');
          freeShippingSubMessage = I18n.t('js.editSubmissionListPage.webComponent.draft.freeShipping.subTitle_4');
        }
        setHtmlElementContent(this.shadowRoot, "free_shipping_sub_message", freeShippingSubMessage)
      } else {
        freeShippingMessage = I18n.t('js.editSubmissionListPage.webComponent.draft.freeShipping.mainTitle_1').replace('amount', parseAmount(this.props.submissionList.grader_company.shipping_discount_sub_list_amount_threshold, 0));
        if (this.props.submissionList.customer_base_service_amount >= Math.ceil(this.props.submissionList.grader_company.shipping_discount_sub_list_amount_threshold / 2))
          freeShippingMessage += I18n.t('js.editSubmissionListPage.webComponent.draft.freeShipping.subTitle_1');
        setHtmlElementContent(this.shadowRoot, "free_shipping_sub_message", '')
      }
      setHtmlElementContent(this.shadowRoot, "free_shipping_message", freeShippingMessage)
    } else {
      addHtmlElementClass(this.shadowRoot, "free_shipping", "d-none");
      removeHtmlElementClass(this.shadowRoot, "free_shipping", "d-block");
    }




    // Gestisco il rendering sull'interfaccia grafica del servizio proposto all'utente
    // relativo al ritiro a domicilio del pacco contenente tutti i prodotti da gradare
    if (this.props.submissionList.grader_company.home_pick_up_method)
      removeHtmlElementClass(this.shadowRoot, "home_pick_up_service", "d-none");
    else {
      this.handleRenderingSubbanner('home_pick_up_address', false);
      addHtmlElementClass(this.shadowRoot, 'home_pick_up_service', 'd-none');
    }

    if (this.props.submissionList.home_pick_up_requested) {
      removeHtmlElementClass(this.shadowRoot, 'home_pick_up_service', "shadow");
      this.handleRenderingSubbanner('home_pick_up_address', true, () => {
        removeHtmlElementClass(this.shadowRoot, 'home_pick_up_cost_present', 'd-none');
        addHtmlElementClass(this.shadowRoot, 'home_pick_up_cost_present', 'd-flex');
        removeHtmlElementClass(this.shadowRoot, 'home_pick_up_cost_absent', 'd-flex');
        addHtmlElementClass(this.shadowRoot, 'home_pick_up_cost_absent', 'd-none');
        setHtmlElementValue(this.shadowRoot, 'favorite_day', this.props.submissionList.home_pick_up_favorite_day);
        selectHtmlElement(this.shadowRoot, isDefined(this.props.submissionList.home_pick_up_favorite_hour) ? `time_range_${this.props.submissionList.home_pick_up_favorite_hour}` : 'no_hour', "selected");
        if (!this.props.submissionList.valid_home_pick_up_favorite_day)
          removeHtmlElementClass(this.shadowRoot, 'invalid-home-pick-up-date-message', 'd-none');
        else
          addHtmlElementClass(this.shadowRoot, 'invalid-home-pick-up-date-message', 'd-none');
      });
    } else {
      this.handleRenderingSubbanner('home_pick_up_address', false, () => {
        addHtmlElementClass(this.shadowRoot, 'home_pick_up_cost_present', 'd-none');
        removeHtmlElementClass(this.shadowRoot, 'home_pick_up_cost_present', 'd-flex');
        removeHtmlElementClass(this.shadowRoot, 'home_pick_up_cost_absent', 'd-none');
        addHtmlElementClass(this.shadowRoot, 'home_pick_up_cost_absent', 'd-flex');
        addHtmlElementClass(this.shadowRoot, "home_pick_up_service", "shadow");
      });
    }

    // Gestisco il rendering sull'interfaccia grafica degli input tag che permettono all'utente di specificare
    // il giorno e la fascia oraria preferiti dall'utente per il ritiro del pacco a domicilio
    if (this.props.submissionList.is_middleman_for_company && this.props.submissionList.has_shipping_collection) {
      addHtmlElementClass(this.shadowRoot, 'home_pick_up_favorite_date', 'd-none');
      addHtmlElementClass(this.shadowRoot, 'home_pick_up_address_container', 'mt-1');
    }
    else {
      removeHtmlElementClass(this.shadowRoot, 'home_pick_up_favorite_date', 'd-none');
      removeHtmlElementClass(this.shadowRoot, 'home_pick_up_address_container', 'mt-1');
    }

    addHtmlElementEventListener(this.shadowRoot, 'add_home_pick_up_btn', 'click', (e) => this.updateSubmissionList(['grader_company_home_pick_up_method_id'], [this.props.submissionList.grader_company.home_pick_up_method?.id]), true);
    addHtmlElementEventListener(this.shadowRoot, 'remove_home_pick_up_btn', 'click', (e) => this.updateSubmissionList(['grader_company_home_pick_up_method_id'], [null]), true);



    // Gestisco il rendering sull'interfaccia grafica del servizio proposto all'utente
    // relativo alla consegna di ritorno a domicilio del pacco contenente tutti i prodotti gradati
    if (this.props.submissionList.grader_company.return_delivery_method) {
      removeHtmlElementClass(this.shadowRoot, 'return_delivery_service', 'd-none')

      // CASO 1: La casa di gradazione propone all'utente sia il ritiro dei beni gradati direttamente presso la
      // sede della casa di gradazione sia un metodo di consegna di ritorno a domicilio tramite corriere
      if (this.props.submissionList.grader_company.pick_up_by_hand_delivery_method) {
        if (this.props.submissionList.return_delivery_requested) {
          removeHtmlElementClass(this.shadowRoot, 'return_delivery_service', "shadow");
          this.handleRenderingSubbanner('return_delivery_address', true, () => {
            removeHtmlElementClass(this.shadowRoot, 'return_delivery_service_present', "d-none");
            addHtmlElementClass(this.shadowRoot, "return_delivery_service_present", "d-flex");
            addHtmlElementClass(this.shadowRoot, 'return_delivery_service_absent', "d-none");
            removeHtmlElementClass(this.shadowRoot, "return_delivery_service_absent", "d-flex");
            removeHtmlElementClass(this.shadowRoot, 'remove_shipment_btn', "invisible-lg");
          });
        } else {
          this.handleRenderingSubbanner('return_delivery_address', false, () => {
            addHtmlElementClass(this.shadowRoot, 'return_delivery_service_present', 'd-none');
            removeHtmlElementClass(this.shadowRoot, 'return_delivery_service_present', 'd-flex');
            removeHtmlElementClass(this.shadowRoot, 'return_delivery_service_absent', 'd-none');
            addHtmlElementClass(this.shadowRoot, "return_delivery_service_absent", "d-flex");
            addHtmlElementClass(this.shadowRoot, 'return_delivery_service', "shadow");
          });
        }
      }
      // CASO 2: La casa di gradazione propone all'utente solamente un metodo di consegna di ritorno a domicilio tramite
      // corriere e non propone il ritiro dei beni gradati direttamente presso la sede della casa di gradazione
      else {
        this.handleRenderingSubbanner("return_delivery_address", true, () => {
          removeHtmlElementClass(this.shadowRoot, "return_delivery_service_present", "d-none");
          addHtmlElementClass(this.shadowRoot, "return_delivery_service_present", "d-flex");
          addHtmlElementClass(this.shadowRoot, "return_delivery_service_absent", "d-none");
          removeHtmlElementClass(this.shadowRoot, "return_delivery_service_absent", "d-flex");
          addHtmlElementClass(this.shadowRoot, "remove_shipment_btn", "invisible-lg");
          removeHtmlElementClass(this.shadowRoot, 'return_delivery_service', "shadow");
        });
      }
    }
    // CASO 3: La casa di gradazione propone all'utente solamente il ritiro dei beni gradati direttamente presso la
    // sede della casa di gradazione e non propone un metodo di consegna di ritorno a domicilio tramite corriere
    else {
      this.handleRenderingSubbanner('return_delivery_address', false);
      addHtmlElementClass(this.shadowRoot, 'return_delivery_service', 'd-none')
    }

    addHtmlElementEventListener(this.shadowRoot, 'add_shipment_btn', 'click', (e) => this.updateSubmissionList(['grader_company_delivery_method_id'], [this.props.submissionList.grader_company.return_delivery_method?.id]), true);
    addHtmlElementEventListener(this.shadowRoot, 'remove_shipment_btn', 'click', (e) => this.updateSubmissionList(['grader_company_delivery_method_id'], [this.props.submissionList.grader_company.pick_up_by_hand_delivery_method?.id]), true);


    setTimeout(() => {
      if (this.props.submissionList.is_middleman_for_company && this.props.submissionList.has_shipping_collection) {
        addHtmlElementClass(this.shadowRoot, 'home_pick_up_price', 'd-none');
        addHtmlElementClass(this.shadowRoot, 'return_delivery_method_price', 'd-none');
      } else {
        removeHtmlElementClass(this.shadowRoot, 'home_pick_up_price', 'd-none');
        removeHtmlElementClass(this.shadowRoot, 'return_delivery_method_price', 'd-none');
        if (this.props.submissionList.grader_company.return_delivery_method && this.props.submissionList.grader_company.pick_up_by_hand_delivery_method)
          removeHtmlElementClass(this.shadowRoot, 'remove_shipment_btn', 'invisible-lg');
        else
          addHtmlElementClass(this.shadowRoot, 'remove_shipment_btn', 'invisible-lg');
      }
    }, 2 * (EASE_IN_TRANSITION_TIME / 3))




    // Gestisco il rendering sull'interfaccia grafica del servizio proposto all'utente
    // relativo alla possibilità di assicurare il suo pacco durante le spedizioni
    if (this.props.submissionList.grader_company.has_insurance_options) {
      removeHtmlElementClass(this.shadowRoot, "insurance_service", "d-none");

      const touSessionStorageKey = `${INSURANCE_TOU_ACCEPTED_KEY_FOR_SESSION_STORAGE}${this.props.submissionList.id}`;
      const insuranceGuidelinesSessionStorageKey = `${INSURANCE_GUIDELINES_ACCEPTED_KEY_FOR_SESSION_STORAGE}${this.props.submissionList.id}`;
      if (!this.props.submissionList.home_pick_up_requested && !this.props.submissionList.return_delivery_requested) {
        window.sessionStorage.setItem(touSessionStorageKey, JSON.stringify(false));
        window.sessionStorage.setItem(insuranceGuidelinesSessionStorageKey, JSON.stringify(false));
      }
      const acceptedInsuranceTou = window.sessionStorage.getItem(touSessionStorageKey)?.toString() === 'true';
      const acceptedInsuranceGuidelines = window.sessionStorage.getItem(insuranceGuidelinesSessionStorageKey)?.toString() === 'true';

      if (this.insurance || acceptedInsuranceTou || acceptedInsuranceGuidelines) {
        removeHtmlElementClass(this.shadowRoot, "insurance_service", "shadow");
        this.handleRenderingSubbanner('insurance_service_options', true, () => {
          removeHtmlElementClass(this.shadowRoot, 'insurance_present', 'd-none');
          addHtmlElementClass(this.shadowRoot, 'insurance_absent', 'd-none');
          removeHtmlElementClass(this.shadowRoot, 'insurance_absent', 'd-flex');
          addHtmlElementClass(this.shadowRoot, "insurance_ranges", "shadow");
        });

        const row = document.createElement('template');
        row.innerHTML = `
          <p><h6><b>
            ${I18n.t('js.editSubmissionListPage.webComponent.draft.insurance.insurancePackValue')}${
              this.props.submissionList.home_pick_up_requested && this.props.submissionList.return_delivery_requested ?
                `, ${I18n.t('js.editSubmissionListPage.webComponent.draft.insurance.insurancePackCoveragePickUpAndReturnShipment')}`
              :
                this.props.submissionList.home_pick_up_requested ?
                  `, ${I18n.t('js.editSubmissionListPage.webComponent.draft.insurance.insurancePackCoveragePickUp')}`
                :
                  this.props.submissionList.return_delivery_requested ?
                    `, ${I18n.t('js.editSubmissionListPage.webComponent.draft.insurance.insurancePackCoverageReturnShipment')}`
                  :
                    ''
            }
          </b></h6></p>
          
          <div class="row w-100 mx-0" id="insurance-form">
            ${
              this.props.submissionList.grader_company.insurance_ranges.map((insurance_range) =>
                `<div class="col-12 col-sm-6 col-xl-3 mb-2 p-0 px-1">
                  <div class="p-2px bg-aig-gradient br-8px h-100">
                    <div id="insurance_range_${insurance_range.id}"
                        class="d-flex flex-directions-column justify-content-between bg-white-imp br-8px text-center cursor-pointer font-size-18px p-1 h-100">
                      <p>
                        <small>
                          <b>
                            ${I18n.t('js.editSubmissionListPage.webComponent.draft.insurance.lessThan')}<br>
                            ${parseAmount(insurance_range.threshold, 0)}${CURRENCY_EURO}
                          </b>
                        </small>
                      </p>
                      <small>
                        <b>
                          ${I18n.t('js.editSubmissionListPage.webComponent.draft.insurance.price')}:&nbsp;
                          ${
                            parseAmount(insurance_range.amount * (this.props.submissionList.home_pick_up_requested && this.props.submissionList.return_delivery_requested ? 2 : 1), 2)
                          }${CURRENCY_EURO}
                        </b>
                      </small>
                    </div>
                  </div>
                </div>`
              ).join('')
            }
            
            ${
              this.props.submissionList.grader_company.insurance_fee ?
                `<div class="col-12 col-sm-6 col-xl-3 mb-2 p-0 px-1">
                  <div class="p-2px bg-aig-gradient br-8px h-100perc">
                    <div class="bg-white-imp br-8px text-center cursor-pointer font-size-18px h-100perc p-1" id="insurance_range_max">
                      <small>
                        <b>
                          ${I18n.t('js.editSubmissionListPage.webComponent.draft.insurance.lessThan')}
                        </b>
                      </small>
                      <div class="input-group mb-2">
                        <input
                          type="number"
                          value="${this.props.submissionList.estimated_value ? this.props.submissionList.estimated_value : ''}"
                          min="${Number(this.props.submissionList.grader_company.last_insurance_range_threshold + 1)}"
                          max="${this.props.submissionList.grader_company.max_insurable_value ? this.props.submissionList.grader_company.max_insurable_value : Number.MAX_SAFE_INTEGER}"
                          class="form-control submission-list-stimated-value-input ml-3" 
                          name="estimated_value"
                          id="estimated_value"
                        />
                        <div class="input-group-append mr-3">
                          <span class="input-group-text submission-list-stimated-value-input">${CURRENCY_EURO}</span>
                        </div>
                      </div>
                      ${
                        this.props.submissionList.grader_company.max_insurable_value ?
                          `<p class="mb-0">
                            <small>
                              ${I18n.t('js.editSubmissionListPage.webComponent.draft.insurance.maxInsurableValue')}: ${parseAmount(this.props.submissionList.grader_company.max_insurable_value, 2)}${CURRENCY_EURO}
                            </small>
                          </p>`
                        :
                          ``
                      }
                      <small>
                        <b>
                          ${I18n.t('js.editSubmissionListPage.webComponent.draft.insurance.price')}:
                          ${
                            this.props.submissionList.grader_company.insurance_fee * (this.props.submissionList.home_pick_up_requested && this.props.submissionList.return_delivery_requested ? 2 : 1)
                          }%
                          ${I18n.t('js.editSubmissionListPage.webComponent.draft.insurance.onPackDeclaredValue')}
                        </b>
                      </small>
                    </div>
                  </div>
                </div>`
              :
                ``
            }
            
            <div class="col-12 text-right d-flex justify-content-end align-items-center pt-4 pb-1 pr-1 pl-0">
              <input
                type="checkbox"
                class="insuranceCheckbox cursor-pointer mb-2"
                id="insuranceTouCheckbox"
              />
              &nbsp;
              <label class="ml-1 cursor-pointer font-size-1rem" for="insuranceTouCheckbox">
                *${I18n.t('js.editSubmissionListPage.subscribe')}
                <a href="${'/' + this.props.locale + '/grading_service_terms_of_use.html#insurance_service'}"
                   target="_blank"
                   class="text-aiBlue text-underline-imp">
                  ${I18n.t('js.editSubmissionListPage.webComponent.draft.insurance.tou')}
                </a>
              </label>
            </div>
            
            <div class="col-12 text-right d-flex justify-content-end align-items-center pb-1 pr-1 pl-0">
              <input
                  type="checkbox"
                  class="insuranceCheckbox cursor-pointer mb-2"
                  id="insuranceGuidelinesCheckbox"
              />
              &nbsp;
              <label class="ml-1 cursor-pointer font-size-1rem" for="insuranceGuidelinesCheckbox">
                *${I18n.t('js.editSubmissionListPage.webComponent.draft.insurance.acceptance')}
                <a href="${'/' + this.props.locale + '/grading_service_terms_of_use.html#insurance_guidelines'}"
                   target="_blank"
                   class="text-aiBlue text-underline-imp">
                  ${I18n.t('js.editSubmissionListPage.webComponent.draft.insurance.guidelines')}
                </a>
              </label>
            </div>
          </div>
        `
        removeHtmlChildren(getHtmlElement(this.shadowRoot, 'insurance-ranges-container'));
        appendHtmlElementChild(getHtmlElement(this.shadowRoot, 'insurance-ranges-container'), row.content.cloneNode(true));

        for (const insurance_range of this.props.submissionList.grader_company.insurance_ranges)
          addHtmlElementEventListener(this.shadowRoot, `insurance_range_${insurance_range.id}`, 'click', (e) => this.handleChangeInsuranceRange(insurance_range), true);

        if (this.props.submissionList.grader_company.insurance_fee)
          addHtmlElementEventListener(this.shadowRoot, `insurance_range_max`, 'click', (e) => this.handleChangeInsuranceRange('max'), true);

        if (this.insuranceRangeId) {
          addHtmlElementClass(this.shadowRoot, `insurance_range_${this.insuranceRangeId}`, "bg-transparent-imp");
          addHtmlElementClass(this.shadowRoot, `insurance_range_${this.insuranceRangeId}`, "border-none-imp");
          addHtmlElementClass(this.shadowRoot, `insurance_range_${this.insuranceRangeId}`, "text-white");
        }

        if (this.insuranceRangeId === 'max') {
          addHtmlElementEventListener(this.shadowRoot, 'estimated_value', 'input', (e) => {
            if (!this.props.submissionList.grader_company.max_insurable_value || e.target.value <= this.props.submissionList.grader_company.max_insurable_value) {
              setHtmlElementValue(this.shadowRoot, 'estimated_value', e.target.value);
              return veryHighDebouncedFunction(this.updateSubmissionList, [['estimated_value'], [e.target.value]]);
            } else {
              setHtmlElementValue(this.shadowRoot, 'estimated_value', this.props.submissionList.grader_company.max_insurable_value);
              return veryHighDebouncedFunction(this.updateSubmissionList, [['estimated_value'], [this.props.submissionList.grader_company.max_insurable_value]]);
            }
          }, true);
        }

        checkHtmlElement(this.shadowRoot, 'insuranceTouCheckbox', acceptedInsuranceTou);
        addHtmlElementEventListener(this.shadowRoot, 'insuranceTouCheckbox', 'change', () => {
          const acceptance = window.sessionStorage.getItem(touSessionStorageKey)?.toString() !== 'true';
          window.sessionStorage.setItem(touSessionStorageKey, JSON.stringify(acceptance));
          this.eventBus.publish('updated-submission-list-state', this.props.submissionList);
          return checkHtmlElement(this.shadowRoot, 'insuranceTouCheckbox', acceptance);
        })

        checkHtmlElement(this.shadowRoot, 'insuranceGuidelinesCheckbox', acceptedInsuranceGuidelines);
        addHtmlElementEventListener(this.shadowRoot, 'insuranceGuidelinesCheckbox', 'change', () => {
          const acceptance = window.sessionStorage.getItem(insuranceGuidelinesSessionStorageKey)?.toString() !== 'true';
          window.sessionStorage.setItem(insuranceGuidelinesSessionStorageKey, JSON.stringify(acceptance));
          this.eventBus.publish('updated-submission-list-state', this.props.submissionList);
          return checkHtmlElement(this.shadowRoot, 'insuranceGuidelinesCheckbox', acceptance);
        })
      }
      else {
        this.handleRenderingSubbanner('insurance_service_options', false, () => {
          addHtmlElementClass(this.shadowRoot, 'insurance_present', 'd-none');
          removeHtmlElementClass(this.shadowRoot, 'insurance_absent', 'd-none');
          addHtmlElementClass(this.shadowRoot, 'insurance_absent', 'd-flex');
          addHtmlElementClass(this.shadowRoot, "insurance_service", "shadow");
        });
      }

      if (!this.props.submissionList.home_pick_up_requested && !this.props.submissionList.return_delivery_requested) {
        enableHtmlElement(this.shadowRoot, 'add_insurance_btn', false);
        addHtmlElementClass(this.shadowRoot, 'add_insurance_btn', 'opacity-0_4');
        removeHtmlElementClass(this.shadowRoot, 'insurance_service_not_available', 'd-none');
      }
      else {
        enableHtmlElement(this.shadowRoot, 'add_insurance_btn', true);
        removeHtmlElementClass(this.shadowRoot, 'add_insurance_btn', 'opacity-0_4');
        addHtmlElementClass(this.shadowRoot, 'insurance_service_not_available', 'd-none');
      }
    }
    else {
      this.handleRenderingSubbanner('insurance_service_options', false);
      addHtmlElementClass(this.shadowRoot, "insurance_service", "d-none");
    }




    // Gestisco il rendering sull'interfaccia grafica del banner che permette all'utente di usare l'eventuale credito
    // accumulato fino a quel momento sul suo wallet
    if (this.props.submissionList.is_middleman_for_company) {
      addHtmlElementClass(this.shadowRoot, 'user_wallet', 'd-none')
      addHtmlElementClass(this.shadowRoot, 'user_wallet_slider_container', 'd-none');
    }
    else {
      this.usedCredit = parseInt(parseAmount(this.props.submissionList.user_credit, 0, true));
      const maxUsableCredit = parseInt(parseAmount(submissionListMaxUsableCredit(this.props.submissionList), 0, true));
      enableHtmlElement(this.shadowRoot, 'user_wallet_slider', maxUsableCredit !== 0)
      setHtmlElementValue(this.shadowRoot, 'user_wallet_slider', maxUsableCredit === 0 ? 0 : parseInt(this.usedCredit * 100 / maxUsableCredit));
      setHtmlElementContent(this.shadowRoot, 'max_usable_credit', maxUsableCredit);
      if (isPresent(this.props.submissionList?.user_wallet?.amount) && this.props.submissionList.user_wallet.amount > maxUsableCredit) {
        setHtmlElementContent(this.shadowRoot, 'wallet_amount', parseAmount(this.props.submissionList.user_wallet.amount, 0, true));
        removeHtmlElementClass(this.shadowRoot, 'fake_slider_container', 'd-none');
        removeHtmlElementClass(this.shadowRoot, 'slider_container', 'col-12');
        addHtmlElementClass(this.shadowRoot, 'slider_container', 'col-9');
      } else {
        addHtmlElementClass(this.shadowRoot, 'fake_slider_container', 'd-none');
        addHtmlElementClass(this.shadowRoot, 'slider_container', 'col-12');
        removeHtmlElementClass(this.shadowRoot, 'slider_container', 'col-9');
      }
      setHtmlElementContent(this.shadowRoot, 'used_wallet_amount', this.usedCredit);
      setHtmlElementContent(this.shadowRoot, 'global_wallet_amount', parseAmount(this.props.submissionList.user_wallet?.amount, 0, true));
      removeHtmlElementClass(this.shadowRoot, 'user_wallet', 'd-none');
      removeHtmlElementClass(this.shadowRoot, 'user_wallet_slider_container', 'd-none');
    }




    // Renderizzo a video i costi dei vari servizi offerti a (ed eventualmente selezionati da) l'utente
    setTimeout(() => {
      if (isPresent(this.props.submissionList.home_pick_up_address)) {
        removeHtmlElementClass(this.shadowRoot, "home_pick_up_price", "d-none");
        addHtmlElementClass(this.shadowRoot, 'home_pick_up_prices_range_disclaimer_1', 'd-none');
        setHtmlElementContent(this.shadowRoot, "home_pick_up_price_1", parsePotentiallyFreeAmount(this.props.submissionList.home_pick_up_cost, 2, true, isDefined(this.props.submissionList.grader_company.shipping_discount_sub_list_amount_threshold) && this.props.submissionList.free_shipping, true).toUpperCase());
      }
      else {
        addHtmlElementClass(this.shadowRoot, "home_pick_up_price", "d-none");
        if (!this.props.submissionList.free_shipping)
          removeHtmlElementClass(this.shadowRoot, 'home_pick_up_prices_range_disclaimer_1', 'd-none');
      }
      const homePickUpPriceRanges = this.props.submissionList.grader_company.home_pick_up_prices_range;
      setHtmlElementContent(this.shadowRoot, 'home_pick_up_price_2',  pricesRangeCollapse(homePickUpPriceRanges, 2, true, this.props.submissionList.free_shipping));
      if (homePickUpPriceRanges?.length > 1 && !this.props.submissionList.free_shipping)
        removeHtmlElementClass(this.shadowRoot, 'home_pick_up_prices_range_disclaimer_2', 'd-none');
      else
        addHtmlElementClass(this.shadowRoot, 'home_pick_up_prices_range_disclaimer_2', 'd-none');

      if (isPresent(this.props.submissionList.shipment_address)) {
        removeHtmlElementClass(this.shadowRoot, "return_delivery_method_price", "d-none");
        addHtmlElementClass(this.shadowRoot, 'return_delivery_prices_range_disclaimer_1', 'd-none');
        setHtmlElementContent(this.shadowRoot, 'return_delivery_method_price_1', parsePotentiallyFreeAmount(this.props.submissionList.shipping_cost, 2, true, isDefined(this.props.submissionList.grader_company.shipping_discount_sub_list_amount_threshold) && this.props.submissionList.free_shipping, true).toUpperCase());
      } else {
        addHtmlElementClass(this.shadowRoot, "return_delivery_method_price", "d-none");
        if (!this.props.submissionList.free_shipping)
          removeHtmlElementClass(this.shadowRoot, 'return_delivery_prices_range_disclaimer_1', 'd-none');
      }
      const returnDeliveryPriceRanges = this.props.submissionList.grader_company.return_delivery_prices_range;
      setHtmlElementContent(this.shadowRoot, 'return_delivery_method_price_2', pricesRangeCollapse(returnDeliveryPriceRanges, 2, true, this.props.submissionList.free_shipping));
      if (returnDeliveryPriceRanges?.length > 1 && !this.props.submissionList.free_shipping)
        removeHtmlElementClass(this.shadowRoot, 'return_delivery_prices_range_disclaimer_2', 'd-none');
      else
        addHtmlElementClass(this.shadowRoot, 'return_delivery_prices_range_disclaimer_2', 'd-none');

      setHtmlElementContent(this.shadowRoot, 'insurance_cost', parseAmount(this.props.submissionList.insurance_cost, 2));
    }, 2 * (EASE_IN_TRANSITION_TIME / 3))
  }


  // Funzione che gestisce il caso in cui l'utente scelga di applicare un'assicurazione al suo pacco oppure no
  handleChangeInsuranceService(choice) {
    const touSessionStorageKey = `${INSURANCE_TOU_ACCEPTED_KEY_FOR_SESSION_STORAGE}${this.props.submissionList.id}`;
    const insuranceGuidelinesSessionStorageKey = `${INSURANCE_GUIDELINES_ACCEPTED_KEY_FOR_SESSION_STORAGE}${this.props.submissionList.id}`;
    if (!choice) {
      window.sessionStorage.setItem(touSessionStorageKey, JSON.stringify(false));
      window.sessionStorage.setItem(insuranceGuidelinesSessionStorageKey, JSON.stringify(false));
    }
    this.insurance = choice;
    if (!this.insurance) {
      this.updateSubmissionList(["insurance_range_id", "insurance_cost", "estimated_value"], [null, null, null]);
    } else {
      this.refreshInterface();
      setTimeout(() => scrollHtmlElementIntoView(this.shadowRoot, "insurance_service_options", false), 2 * (EASE_IN_TRANSITION_TIME / 3));
    }
  }


  // Funzione che gestisce il cambio della fascia assicurativa scelta dall'utente per il suo pacco
  handleChangeInsuranceRange(newInsuranceRange) {
    if (this.insuranceRangeId !== newInsuranceRange?.id && this.insuranceRangeId !== newInsuranceRange) {
      for (const insurance_range of this.props.submissionList.grader_company.insurance_ranges)
        addHtmlElementClass(this.shadowRoot, `insurance_range_${insurance_range.id}`, "border-light-gray");
      addHtmlElementClass(this.shadowRoot, `insurance_range_max`, "border-light-gray");

      if (newInsuranceRange !== 'max') {
        this.insuranceRangeId = newInsuranceRange.id;
        this.updateSubmissionList(['insurance_range_id', 'insurance_cost', 'estimated_value'], [this.insuranceRangeId, newInsuranceRange.amount, null])
      } else {
        this.insuranceRangeId = newInsuranceRange;
        this.updateSubmissionList(['insurance_range_id', 'insurance_cost', 'estimated_value'], [null, null, this.props.submissionList.grader_company.last_insurance_range_threshold + 1]);
      }

      addHtmlElementClass(this.shadowRoot, `insurance_range_${this.insuranceRangeId}`, 'bg-transparent-imp');
      addHtmlElementClass(this.shadowRoot, `insurance_range_${this.insuranceRangeId}`, "border-none-imp");
      addHtmlElementClass(this.shadowRoot, `insurance_range_${this.insuranceRangeId}`, 'text-white');
    }
  }


  // Funzione che gestisce il trascinamento dello slider che permette all'utente di specificare quanto credito usare
  // per pagare l'ordine
  handleDragUserWalletSlider (e) {
    const range = getHtmlElement(this.shadowRoot, 'user_wallet_slider');
    if (range && this.isUserWalletSliderDragging) {
      const maxUsableCredit = parseInt(parseAmount(submissionListMaxUsableCredit(this.props.submissionList), 0, true));
      const boundingRect = range.getBoundingClientRect();
      const percentage = (e.clientX - boundingRect.left) / boundingRect.width;
      range.value = parseInt(Math.min(Math.max(percentage * 100, 0), Math.max(maxUsableCredit, 100)));
    }
  }


  // Funzione che gestisce il cambio del credito che l'utente ha deciso di usare per pagare l'ordine
  handleOnUserWalletSliderChange (e) {
    const maxUsableCredit = parseInt(parseAmount(submissionListMaxUsableCredit(this.props.submissionList), 0, true));
    this.usedCredit = parseInt((e.target.value * maxUsableCredit) / 100);
    setHtmlElementContent(this.shadowRoot, 'used_wallet_amount', this.usedCredit);
  }


  // Funzione che gestisce il rilascio del mouse dallo slider che permette all'utente di specificare quanto credito
  // usare per pagare l'ordine
  handleOnUserWalletSliderMouseUp () {
    if (this.isUserWalletSliderDragging) {
      this.isUserWalletSliderDragging = false;
      const maxUsableCredit = parseInt(parseAmount(submissionListMaxUsableCredit(this.props.submissionList), 0, true));
      if (maxUsableCredit > 0)
        this.updateSubmissionList(['user_credit'], [this.usedCredit]);
      else
        this.updateSubmissionListState(this.props.submissionList);
    }
  }


  // Funzione che setta i parametri di assicurazione da renderizzare sull'interfaccia grafica
  setInsuranceParams() {
    this.insuranceRangeId = this.props.submissionList.insurance_range_id ? this.props.submissionList.insurance_range_id : (this.props.submissionList.estimated_value ? 'max' : null)
    this.submissionListEstimatedValue = this.props.submissionList.estimated_value && this.props.submissionList.estimated_value > 0.0 ? this.props.submissionList.estimated_value : null
    this.insurance = isDefined(this.insuranceRangeId) || isDefined(this.submissionListEstimatedValue)
  }


  // Funzione che aggiorna lo stato corrente della submission list quando gli altri componenti segnalano tale evento sull'eventBus
  updateSubmissionListState(submissionList) {
    this.props.submissionList = { ...submissionList };
    this.setInsuranceParams();
    this.refreshInterface();
  }


  // Funzione che setta un nuovo valore associato alla submission list
  setSubmissionList(key, value) {
    this.props.submissionList[key] = value;
  }


  // Funzione che si occupa di aggiornare la submission list mediante richiesta http al server
  updateSubmissionList = (keys, values) => {
    const url = `/submission_lists/${this.props.submissionList.id}`;

    const body = {}
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const value = sanitize(values[i]);
      this.setSubmissionList(key, value);
      body[key] = value;
    }

    fetch(url + ".json", {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    })
      .then((response) => {
        if (!response.ok)
          throw Error("An error occour during saving data on the database");
        else
          return response.json();
      })
      .then((submissionList) => {
        this.eventBus.publish('updated-submission-list-state', submissionList);
        this.eventBus.publish('render-new-success-flash-message');
        
        if (keys.includes('grader_company_id'))
          this.eventBus.publish('updated-items-prices', submissionList);
        else {
          if (keys.includes('grader_company_home_pick_up_method_id') && submissionList.grader_company_home_pick_up_method_id)
            setTimeout(() => scrollHtmlElementIntoView(this.shadowRoot, "home_pick_up_address", false), 2 * (EASE_IN_TRANSITION_TIME / 3));

          if (keys.includes('grader_company_delivery_method_id') && submissionList.grader_company_delivery_method_id)
            setTimeout(() => scrollHtmlElementIntoView(this.shadowRoot, "return_delivery_address", false), 2 * (EASE_IN_TRANSITION_TIME / 3));
        }
      })
      .catch((error) => {
        console.error("ERROR:", error);
        this.eventBus.publish('render-modal', {error: true});
      });
  }




  render() {
    const html = `      
      <div class="mt-4 pt-2 align-items-center" id="additional_services_container">
        <!-- SEZIONE INFORMATIVA SULLE SPEDIZIONI GRATUITE -->
        <div class="d-block text-center bg-aig-gradient-light br-8px shadow mx-0 mb-5 p-3" id="free_shipping">
          <h5 class="my-0 text-aig-gradient">
            <b id="free_shipping_message"></b>
          </h5>
          <p class="mb-0 mt-1" id="free_shipping_sub_message"></p>
        </div>
        
        
        
        
        
        <!-- TITOLO DELLA SEZIONE -->
        <div class="row d-flex justify-content-center text-center text-aig-gradient mb-0 mt-4 pb-0">
          <h2 class="mb-0"><b>${I18n.t('js.editSubmissionListPage.webComponent.draft.additionalServicesTitle')}</b></h2>
        </div>
        
        
        
        
        
        <!-- SEZIONE RITIRO A DOMICILIO DEL PACCO -->
        <div class="row border-solid br-20px mt-2 shadow mx-0" id="home_pick_up_service">
          <div class="col-12 col-md-2 py-3 py-md-0 d-flex justify-content-center align-items-center bg-aig-gradient border-left-radius-20px shipment-icon-container z-index-10">
            <img src="/images/icons/white/home_pick_up.svg" 
              alt="" width="90" 
            >
          </div>
         
          <div class="col-12 col-md-10">
            <div class="row">
              <div class="col-12 col-lg-7 pb-2">
                <p>
                  <h6>
                    <b class="mr-1">${I18n.t('js.editSubmissionListPage.webComponent.draft.homePickUp')}</b>
                    <question-tooltip-component
                      props='${obj2string({
                        title: I18n.t("js.editSubmissionListPage.webComponent.questiontip.home_pickup_p1"),
                        body: [I18n.t("js.editSubmissionListPage.webComponent.questiontip.home_pickup_p2"),
                               I18n.t("js.editSubmissionListPage.webComponent.questiontip.home_pickup_p3")]
                      })}'
                    ></question-tooltip-component>
                  </h6>
                </p>
                <div class="d-block mt--8px-imp">
                  <div class="d-flex mb-0">
                    <img src="/images/icons/confirmation.svg" alt="" width="15" height="15" class="mt-1"> 
                    <div class="pl-2">
                      ${I18n.t("js.editSubmissionListPage.webComponent.draft.homePickUpBullet1")}
                    </div>
                  </div>
                  <div class="d-flex mb-0">
                    <img src="/images/icons/confirmation.svg" alt="" width="15" height="15" class="mt-1"> 
                    <div class="pl-2">
                      ${I18n.t("js.editSubmissionListPage.webComponent.draft.homePickUpBullet2")}
                    </div>
                  </div>
                  <div class="d-flex mb-0">
                    <img src="/images/icons/confirmation.svg" alt="" width="15" height="15" class="mt-1"> 
                    <div class="pl-2">
                      ${I18n.t("js.editSubmissionListPage.webComponent.draft.homePickUpBullet3")}
                    </div>
                  </div>
                </div>
              </div>
              
              
              <div class="col-12 col-lg-5 pb-2 pt-3 text-right d-none justify-content-end flex-directions-column" id="home_pick_up_cost_present">
                <h6 id="home_pick_up_price" class="font-weight-bold mb-3 mb-lg-5 pb-lg-1">
                  <span id="home_pick_up_price_1">
                    ${parsePotentiallyFreeAmount(this.props.submissionList.home_pick_up_cost, 2, true, isDefined(this.props.submissionList.grader_company.shipping_discount_sub_list_amount_threshold) && this.props.submissionList.free_shipping, true).toUpperCase()}
                  </span>
                </h6>
                
                <button
                  id="remove_home_pick_up_btn"
                  class="btn bg-red color-white br-50px text-center px-3 mr-0 mb-1 ml-auto"
                  type="button"
                >
                   ${I18n.t('js.common.button.delete').toUpperCase()}
                </button>
                
                <p class="p-0 pt-lg-1 mx-0 mt-2 mt-lg-4 mb-0 color-gray d-none" id="home_pick_up_prices_range_disclaimer_1">
                  ${I18n.t("js.editSubmissionListPage.webComponent.draft.shipmentServicesDisclaimer1")}<br>
                  ${I18n.t("js.editSubmissionListPage.webComponent.draft.shipmentServicesDisclaimer2")}
                </p>
              </div>
              
              <div class="col-12 col-lg-5 text-right pt-3 pb-2 d-none justify-content-end flex-directions-column" id="home_pick_up_cost_absent">
                <button
                  id="add_home_pick_up_btn"
                  class="btn-standard bg-aig-gradient color-white br-50px border-none-imp text-center px-4 px-xl-5 mr-0 ml-auto"
                  type="button"
                >
                   ${I18n.t('js.common.button.add').toUpperCase()}<b id="home_pick_up_price_2">${pricesRangeCollapse(this.props.submissionList.grader_company.home_pick_up_prices_range, 2, true, this.props.submissionList.free_shipping)}</b>
                </button>
                
                <p class="p-0 pt-lg-1 mx-0 mt-2 mt-lg-3 mb-0 color-gray d-none" id="home_pick_up_prices_range_disclaimer_2">
                  ${I18n.t("js.editSubmissionListPage.webComponent.draft.shipmentServicesDisclaimer1")}<br>
                  ${I18n.t("js.editSubmissionListPage.webComponent.draft.shipmentServicesDisclaimer2")}
                </p>
              </div>
            </div>
          </div>
        </div>      
      
        <div class="row slide-animation-container mx-0" id="home_pick_up_address">
          <div class="col-12 col-md-2"></div>
          
          <div class="col-12 col-md-10 pt-3 border-bottom-radius-20px border-bottom-solid border-right-solid border-left-solid shadow-on-left-bottom-right">
            <div class="row" id="home_pick_up_favorite_date">
              <div class="col-6 d-flex flex-directions-column justify-content-between text-left border-right-solid border-bottom-solid mt-1 pt-2 pb-1 pr-1" id="favorite_day_container">
                <div class="row">
                  <div class="col-12 col-lg-6">
                    <div class="d-flex justify-content-start">
                      <small class="color-gray mr-2 font-size-14px">${I18n.t('js.editSubmissionListPage.webComponent.draft.homePickUpFavoriteDayTitle').toUpperCase()}</small>
                      <question-tooltip-component
                        props='${obj2string({
                          title: I18n.t("js.editSubmissionListPage.webComponent.questiontip.home_pickup_p4_0"),
                          body: [I18n.t('js.common.hello') + ' ' + this.props.currentUserGenerality + '.',
                            I18n.t('js.editSubmissionListPage.webComponent.draft.homePickUpFavoriteDaySubTitle'),
                            this.props.submissionList.home_pick_up_time_range_italian_format[0] + ' ' +
                            I18n.t('js.editSubmissionListPage.webComponent.draft.homePickUpFavoriteDaySubTitle_1') + ' ' +
                            this.props.submissionList.home_pick_up_time_range_italian_format[1] + ', ',
                            I18n.t('js.editSubmissionListPage.webComponent.draft.homePickUpFavoriteDaySubTitle_2')],
                          id: "favorite_day_container"
                        })}'
                      ></question-tooltip-component>
                    </div>
                  
                    <input
                      type="date"
                      class="form-control supplementary-item-form-input border-left-radius-3px-imp w-100"
                      name="favorite_day"
                      id="favorite_day"
                      min="${this.props.submissionList.home_pick_up_time_range_iso_format[0]}"
                      max="${this.props.submissionList.home_pick_up_time_range_iso_format[1]}"
                    />
                  </div>
                </div>
                
                <div class="col-12 px-0 pt-1 text-aiBlue d-none" id="invalid-home-pick-up-date-message">
                  ${I18n.t('js.editSubmissionListPage.webComponent.draft.homePickUpFavoriteDateInvalidMessage')}
                </div>
              </div>
              
              <div class="col-6 d-flex flex-directions-column justify-content-between text-left border-bottom-solid mt-1 pt-2 pb-1 pr-1" id="favorite_hour_container">
                <div class="row">
                  <div class="col-12 col-lg-6">
                    <div class="d-flex justify-content-start">
                      <small class="color-gray mr-2 font-size-14px">${I18n.t('js.editSubmissionListPage.webComponent.draft.homePickUpTimeRange').toUpperCase()}</small>
                      <question-tooltip-component
                        props='${obj2string({
                          title: I18n.t("js.editSubmissionListPage.webComponent.questiontip.home_pickup_p4"),
                          body: [I18n.t("js.editSubmissionListPage.webComponent.questiontip.home_pickup_p5"),
                            I18n.t("js.editSubmissionListPage.webComponent.questiontip.home_pickup_p6"),
                            I18n.t("js.editSubmissionListPage.webComponent.questiontip.home_pickup_p7")],
                          id: "favorite_hour_container"
                        })}'
                      ></question-tooltip-component>
                    </div>
                
                    <select 
                      class="form-control supplementary-item-form-input supplementary-item-form-select w-100"
                      name="favorite_hour" 
                      id="favorite_hour"
                    >
                      <option value="" id="no_hour">
                        ${I18n.t('js.editSubmissionListPage.webComponent.draft.selectAnOption')}
                      </option>
                      ${SUBMISSION_LISTS_HOME_PICK_UP_TIME_RANGES.map((time_range) =>
                        `<option value=${time_range} id="time_range_${time_range}">
                           ${time_range !== 'all_day' ? parseTimeRange(time_range) : I18n.t('js.editSubmissionListPage.webComponent.draft.homePickUpAnyHour')}
                        </option>`
                      ).join('')}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="row">
              <div class="col-12 col-md-6 text-left border-bottom-solid border-bottom-md-none border-right-md-solid pt-2 pb-1 pr-1" id="home_pick_up_address_container">
                <div class="d-flex justify-content-start">
                  <small class="color-gray mr-2 font-size-14px">${I18n.t('js.editSubmissionListPage.webComponent.draft.homePickUpAddressTitle').toUpperCase()}</small>
                  <question-tooltip-component
                    props='${obj2string({
                      title: I18n.t('js.editSubmissionListPage.webComponent.draft.homePickUpAddressTitle'),
                      body: [I18n.t("js.editSubmissionListPage.webComponent.questiontip.home_pickup_address_p1"),
                             I18n.t("js.editSubmissionListPage.webComponent.questiontip.shipment_address_p2")],
                      id: "home_pick_up_address_container"
                    })}'
                  ></question-tooltip-component>
                </div>
                
                <submission-list-address-component
                  props='${obj2string({
                    submissionList: this.props.submissionList,
                    address_type: 'home_pick_up'
                  })}'
                ></submission-list-address-component>
              </div>
              
              <div class="col-12 col-md-6 text-left pt-2 pb-1 pr-1" id="home_pick_up_note_container">
                <div class="d-flex justify-content-start">
                  <small class="color-gray mr-2 font-size-14px">${I18n.t('js.newUserAddressForm.note').toUpperCase()}</small>
                  <question-tooltip-component
                    props='${obj2string({
                      title: I18n.t('js.newUserAddressForm.noteForCourier'),
                      body: [I18n.t("js.editSubmissionListPage.webComponent.questiontip.shipment_note_p1")],
                      id: "home_pick_up_note_container"
                    })}'
                  ></question-tooltip-component>
                </div>
                
                <textarea 
                  name="note" id="home_pick_up_note"
                  rows="5" cols="20" 
                  class="form-control optional_note overflow-hidden supplementary-item-form-input border-left-radius-3px-imp pt-1"
                  placeholder="${I18n.t('js.newUserAddressForm.noteForCourierOptional')}"
                >${ this.props.submissionList.home_pick_up_note ? this.props.submissionList.home_pick_up_note : '' }</textarea>
              </div>
            </div>
          </div>
        </div>
        
        
        
        
        
        <!-- SEZIONE SPEDIZIONE DI RITORNO -->
        <div class="row border-solid br-20px mt-5 mx-0" id="return_delivery_service">
          <div class="col-12 col-md-2 py-3 py-md-0 d-flex justify-content-center align-items-center bg-aig-gradient border-left-radius-20px shipment-icon-container z-index-10">
            <img src="/images/icons/white/shipment.svg" 
              alt="" width="90" 
            >
          </div>
          
          <div class="col-12 col-md-10">
            <div class="row">
              <div class="col-12 col-lg-7 pb-2">
                <p>
                  <h6>
                    <b class="mr-1">${I18n.t('js.editSubmissionListPage.webComponent.draft.deliveryMethod')}</b>
                    <question-tooltip-component
                      props='${obj2string({
                        title: I18n.t("js.editSubmissionListPage.webComponent.questiontip.return_delivery_p1"),
                        body: [I18n.t("js.editSubmissionListPage.webComponent.questiontip.return_delivery_p2"),
                               I18n.t("js.editSubmissionListPage.webComponent.questiontip.return_delivery_p3")]
                      })}'
                    ></question-tooltip-component>
                  </h6>
                </p>
                <div class="d-block mt--8px-imp">
                  <div class="d-flex mb-0">
                    <img src="/images/icons/confirmation.svg" alt="" width="15" height="15" class="mt-1"> 
                    <div class="pl-2">
                      ${I18n.t("js.editSubmissionListPage.webComponent.draft.returnDeliveryBullet1")}
                    </div>
                  </div>
                  <div class="d-flex mb-0">
                    <img src="/images/icons/confirmation.svg" alt="" width="15" height="15" class="mt-1"> 
                    <div class="pl-2">
                      ${I18n.t("js.editSubmissionListPage.webComponent.draft.returnDeliveryBullet2")}
                    </div>
                  </div>
                  <div class="d-flex mb-0">
                    <img src="/images/icons/confirmation.svg" alt="" width="15" height="15" class="mt-1"> 
                    <div class="pl-2">
                      ${I18n.t("js.editSubmissionListPage.webComponent.draft.returnDeliveryBullet3")}
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="col-12 col-lg-5 pb-2 pt-3 text-right d-none justify-content-end flex-directions-column" id="return_delivery_service_present">
                <h6 id="return_delivery_method_price" class="font-weight-bold mb-3 mb-lg-5 pb-lg-1">
                  <span id="return_delivery_method_price_1">
                    ${parsePotentiallyFreeAmount(this.props.submissionList.shipping_cost, 2, true, isDefined(this.props.submissionList.grader_company.shipping_discount_sub_list_amount_threshold) && this.props.submissionList.free_shipping, true).toUpperCase()}
                  </span>
                </h6>
                
                <button
                  id="remove_shipment_btn"
                  class="btn bg-red color-white br-50px text-center px-3 mr-0 mb-1 ml-auto"
                  type="button"
                >
                   ${I18n.t('js.common.button.delete').toUpperCase()}
                </button>
                
                <p class="p-0 pt-lg-1 mx-0 mt-2 mt-lg-4 mb-0 color-gray d-none" id="return_delivery_prices_range_disclaimer_1">
                  ${I18n.t("js.editSubmissionListPage.webComponent.draft.shipmentServicesDisclaimer1")}<br>
                  ${I18n.t("js.editSubmissionListPage.webComponent.draft.shipmentServicesDisclaimer3")}
                </p>
              </div>
              
              <div class="col-12 col-lg-5 text-right pt-3 pb-2 d-none justify-content-end flex-directions-column" id="return_delivery_service_absent">
                <button
                  id="add_shipment_btn"
                  class="btn-standard bg-aig-gradient color-white br-50px border-none-imp text-center px-4 px-xl-5 mr-0 ml-auto"
                  type="button"
                >
                   ${I18n.t('js.common.button.add').toUpperCase()}<b id="return_delivery_method_price_2">${pricesRangeCollapse(this.props.submissionList.grader_company.return_delivery_prices_range, 2, true, this.props.submissionList.free_shipping)}</b>
                </button>
                
                <p class="p-0 pt-lg-1 mx-0 mt-2 mt-lg-3 mb-0 color-gray d-none" id="return_delivery_prices_range_disclaimer_2">
                  ${I18n.t("js.editSubmissionListPage.webComponent.draft.shipmentServicesDisclaimer1")}<br>
                  ${I18n.t("js.editSubmissionListPage.webComponent.draft.shipmentServicesDisclaimer3")}
                </p>
              </div>
            </div>
          </div>
        </div>
        
        <div class="row slide-animation-container mx-0" id="return_delivery_address">
          <div class="col-12 col-md-2"></div>
          
          <div class="col-12 col-md-10 pt-3 border-bottom-radius-20px border-bottom-solid border-right-solid border-left-solid shadow-on-left-bottom-right">
            <div class="row">
              <div class="col-12 col-md-6 text-left border-bottom-solid border-bottom-md-none border-right-md-solid mt-1 pt-2 pb-1 pr-1" id="shipment_address_container">
                <div class="d-flex justify-content-start">
                  <small class="color-gray mr-2 font-size-14px">${I18n.t('js.editSubmissionListPage.webComponent.draft.shipmentAddressTitle').toUpperCase()}</small>
                  <question-tooltip-component
                    props='${obj2string({
                      title: I18n.t('js.editSubmissionListPage.webComponent.draft.shipmentAddressTitle'),
                      body: [I18n.t("js.editSubmissionListPage.webComponent.questiontip.shipment_address_p1"),
                             I18n.t("js.editSubmissionListPage.webComponent.questiontip.shipment_address_p2")],
                      id: "shipment_address_container"
                    })}'
                  ></question-tooltip-component>
                </div>
                
                <submission-list-address-component
                  props='${obj2string({
                    submissionList: this.props.submissionList,
                    address_type: 'shipment'
                  })}'
                ></submission-list-address-component>
              </div>
              
              <div class="col-12 col-md-6 text-left mt-1 pt-2 pb-1 pr-1" id="shipment_note_container">
                <div class="d-flex justify-content-start">
                  <small class="color-gray mr-2 font-size-14px">${I18n.t('js.newUserAddressForm.note').toUpperCase()}</small>
                  <question-tooltip-component
                    props='${obj2string({
                      title: I18n.t('js.newUserAddressForm.noteForCourier'),
                      body: [I18n.t("js.editSubmissionListPage.webComponent.questiontip.shipment_note_p2")],
                      id: "shipment_note_container"
                    })}'
                  ></question-tooltip-component>
                </div>
                
                <textarea 
                  name="note" id="shipment_note"
                  rows="5" cols="20" 
                  class="form-control optional_note overflow-hidden supplementary-item-form-input border-left-radius-3px-imp pt-1"
                  placeholder="${I18n.t('js.newUserAddressForm.noteForCourierOptional')}"
                >${ this.props.submissionList.shipment_note ? this.props.submissionList.shipment_note : '' }</textarea>
              </div>
            </div>
          </div>
        </div>
        
        
        
        
        
        <!-- SEZIONE ASSICURAZIONI -->
        <div class="row border-solid br-20px mt-5 mx-0" id="insurance_service">
          <div class="col-12 col-md-2 d-flex justify-content-center align-items-center bg-aig-gradient border-left-radius-20px shipment-icon-container py-2 z-index-10">
            <img src="/images/icons/white/shield.svg" 
                alt="" width="65" height="65" 
            >
          </div>
          
          <div class="col-12 col-md-10">
            <div class="row">
              <div class="col-12 col-lg-7 pb-2">
                <p>
                  <h6>
                    <b class="mr-1">${I18n.t('js.editSubmissionListPage.webComponent.draft.insuranceService')}</b>
                    <question-tooltip-component
                      props='${obj2string({
                        title: I18n.t("js.editSubmissionListPage.webComponent.questiontip.insurance_p1"),
                        body: [I18n.t("js.editSubmissionListPage.webComponent.questiontip.insurance_p2"),
                               I18n.t("js.editSubmissionListPage.webComponent.questiontip.insurance_p3")]
                      })}'
                    ></question-tooltip-component>
                  </h6>
                </p>
                <div class="d-block mt--8px-imp">
                  <div class="d-flex mb-0">
                    <img src="/images/icons/confirmation.svg" alt="" width="15" height="15" class="mt-1"> 
                    <div class="pl-2">
                      ${I18n.t("js.editSubmissionListPage.webComponent.draft.insuranceBullet1")}
                    </div>
                  </div>
                  <div class="d-flex mb-0">
                    <img src="/images/icons/confirmation.svg" alt="" width="15" height="15" class="mt-1"> 
                    <div class="pl-2">
                      ${I18n.t("js.editSubmissionListPage.webComponent.draft.insuranceBullet2")}
                    </div>
                  </div>
                  <div class="d-flex mb-0">
                    <img src="/images/icons/confirmation.svg" alt="" width="15" height="15" class="mt-1"> 
                    <div class="pl-2">
                      ${I18n.t("js.editSubmissionListPage.webComponent.draft.insuranceBullet3")}
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="col-12 col-lg-5 py-3 text-right d-none justify-content-end flex-directions-column" id="insurance_present">
                <h6 class="font-weight-bold mb-3 mb-lg-5 pb-lg-1">
                  +<span id="insurance_cost">
                    ${parseAmount(this.props.submissionList.insurance_cost, 2, true)}
                  </span>${CURRENCY_EURO}
                </h6>
                
                <button
                  id="remove_insurance_btn"
                  class="btn bg-red color-white br-50px text-center px-3 mr-0 ml-auto"
                  type="button"
                >
                   ${I18n.t('js.common.button.delete').toUpperCase()}
                </button>
              </div>
              
              <div class="col-12 col-lg-5 text-right pt-3 pb-2 d-none justify-content-end flex-directions-column" id="insurance_absent">
                <button
                  id="add_insurance_btn"
                  class="btn-standard bg-aig-gradient color-white br-50px border-none-imp text-center px-4 px-xl-5 mr-0 ml-auto"
                  type="button"
                >
                   ${I18n.t('js.common.button.add').toUpperCase()}
                </button>
                
                <p class="p-0 pt-lg-1 mx-0 mt-2 mt-lg-3 mb-0 color-gray d-none" id="insurance_service_not_available">
                  ${I18n.t('js.editSubmissionListPage.webComponent.draft.insurance.notAvailableService1')}<br>
                  ${I18n.t('js.editSubmissionListPage.webComponent.draft.insurance.notAvailableService2')}
                </p>
              </div>
            </div>
          </div>
        </div>      
      
        <div class="row slide-animation-container mx-0" id="insurance_service_options">
          <div class="col-12 col-md-2"></div>
          
          <div class="col-12 col-md-10 pt-3 pb-2 border-bottom-radius-20px border-bottom-solid border-right-solid border-left-solid shadow-on-left-bottom-right" 
            id="insurance_ranges">
            <div id="insurance-ranges-container"></div>              
          </div>
        </div>
        
        
        
        
        
        <!-- SEZIONE UTILIZZO DEL CREDITO GIACENTE SUL WALLET UTENTE -->
        <div class="row border-solid br-20px mt-5 mx-0" id="user_wallet">
          <div class="col-12 col-md-2 d-flex justify-content-center align-items-center bg-aig-gradient border-left-radius-20px shipment-icon-container py-2 z-index-10">
            <img src="/images/icons/white/pig.svg" 
                alt="" width="70" height="70" 
            >
          </div>
          
          <div class="col-12 col-md-10">
            <div class="row pb-2">
              <div class="col-12">
                <p>
                  <h6>
                    <b class="mr-1">${I18n.t('js.editSubmissionListPage.webComponent.draft.wallet.title')} </b>
                    <question-tooltip-component
                      props='${obj2string({
                        title: I18n.t("js.editSubmissionListPage.webComponent.questiontip.wallet_p1"),
                        body: [I18n.t("js.editSubmissionListPage.webComponent.questiontip.wallet_p2"),
                          I18n.t("js.editSubmissionListPage.webComponent.questiontip.wallet_p3")]
                      })}'
                    ></question-tooltip-component>
                  </h6>
                </p>
                <div class="d-block mt--8px-imp">
                  <div class="d-flex mb-0">
                    <img src="/images/icons/confirmation.svg" alt="" width="15" height="15" class="mt-1"> 
                    <div class="pl-2">
                      ${I18n.t("js.editSubmissionListPage.webComponent.draft.wallet.useSlider1")}
                    </div>
                  </div>
                  <div class="d-flex mb-0">
                    <img src="/images/icons/confirmation.svg" alt="" width="15" height="15" class="mt-1"> 
                    <div class="pl-2">
                      ${I18n.t("js.editSubmissionListPage.webComponent.draft.wallet.useSlider2")}
                    </div>
                  </div>
                  <div class="d-flex mb-0">
                    <img src="/images/icons/confirmation.svg" alt="" width="15" height="15" class="mt-1"> 
                    <div class="pl-2">
                      ${I18n.t("js.editSubmissionListPage.webComponent.draft.wallet.useSlider3")}
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="col-12 col-lg-4 pt-3 pr-3 d-block justify-content-end text-right align-self-end">
              </div>
            </div>
          </div>
        </div>      
      
        <div class="row mx-0 service-subbanner" id="user_wallet_slider_container">
          <div class="col-12 col-md-2"></div>
          
          <div class="col-12 col-md-10 pb-2 border-bottom-radius-20px border-bottom-solid border-right-solid border-left-solid shadow-on-left-bottom-right">
            <div class="row pb-2 pt-2">
              <div class="col-12 col-md-8 col-lg-7 d-block align-self-center pt-4">
                <div class="row w-100 m-0 p-0">
                  <div class="col-9 w-100 m-0 p-0" id="slider_container">
                    <input type="range" class="w-100 my-2 cursor-pointer" id="user_wallet_slider" min="0" max="100" />
                    <div class="w-100 d-flex justify-content-between py-0">
                      <p class="my-0"><b>0${CURRENCY_EURO}</b></p>
                      <p class="my-0"><b id="max_usable_credit"></b><b>${CURRENCY_EURO}</b></p>
                    </div>
                  </div>
                  
                  <div class="col-3 w-100 m-0 p-0" id="fake_slider_container">               
                    <div class="mb-2" id="fake_slider"></div>
                    <div class="w-100 d-flex justify-content-between py-0">
                      <p class="my-0"><b>&nbsp;</b></p>
                      <p class="my-0"><b id="wallet_amount"></b><b>${CURRENCY_EURO}</b></p>
                    </div>
                  </div>
                </div>  
              </div>
              
              
              <div class="col-12 col-md-4 col-lg-5 pt-4 pr-3 d-flex justify-content-end text-right align-self-end">
                <div class="mr-3 mr-lg-5">
                  <h4 class="mb-0">
                    <span id="used_wallet_amount"></span>${CURRENCY_EURO}
                  </h4>
                  <p class="my-0">
                    ${I18n.t('js.editSubmissionListPage.webComponent.draft.wallet.usedCredit')}
                  </p>
                </div>
                
                <div>
                  <h4 class="mb-0">
                    <span id="global_wallet_amount"></span>${CURRENCY_EURO}
                  </h4>
                  <p class="mt-0 mb-2">
                    ${I18n.t('js.editSubmissionListPage.webComponent.draft.wallet.availableCredit')}
                  </p>
                </div>
              </div>
            </div>              
          </div>
        </div>
    `

    renderWebComponent(html, this.shadowRoot, [commonStyles, submissionListsStyles]);
    this.refreshInterface();
  }
}

window.customElements.define("submission-list-additional-services-component", SubmissionListAdditionalServicesComponent);
